import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartnershipData } from 'api/signUp/signUp.types';
import { REACT_APP_MAIN_SITE_HOMEPAGE } from 'config';
import { RootState } from 'store/store';

type UtilityState = {
  callbackUrl: string;
  partnershipData?: PartnershipData;
};

export type SetEndCallbackUrlActionPayload = {
  value: string;
};
export type SetPartnershipDataActionPayload = {
  partnershipData: PartnershipData;
};

const initialState: UtilityState = {
  callbackUrl: REACT_APP_MAIN_SITE_HOMEPAGE,
};

const utilityValuesSlice = createSlice({
  name: 'utilityValues',
  initialState,
  reducers: {
    setCallbackUrl: (
      state,
      action: PayloadAction<SetEndCallbackUrlActionPayload>,
    ) => {
      const { value } = action.payload;
      state.callbackUrl = value;
      return state;
    },
    setPartnershipData: (
      state,
      action: PayloadAction<SetPartnershipDataActionPayload>,
    ) => {
      const { partnershipData } = action.payload;
      state.partnershipData = partnershipData;
      return state;
    },
  },
});

export const { setCallbackUrl, setPartnershipData } =
  utilityValuesSlice.actions;

export default utilityValuesSlice.reducer;

export const selectCalbackUrl = (state: RootState) =>
  state.utilityValues.callbackUrl;
export const selectPartnershipData = (state: RootState) =>
  state.utilityValues.partnershipData;
